import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useAnticipations = () => useQuery({ queryKey: [`anticipations`], queryFn: async () => {
    const callback = await API.get(`/anticipations`)
    return callback?.data
}, staleTime: 60000, gcTime: 1000 * 60 * 30 })

export default useAnticipations